module.exports = __webpack_public_path__ + "static/media/AR-Option1.2b9809e9.jpg";